import React from 'react';
import { Clock, CheckCircle, XCircle, AlertCircle, Server, Cog, Printer, Pause, RotateCw } from 'lucide-react';

interface PrintJobStatusBadgeProps {
  status: string;
}

export const PrintJobStatusBadge: React.FC<PrintJobStatusBadgeProps> = ({ status }) => {
  const getStatusConfig = (status: string) => {
    const normalizedStatus = status.toLowerCase();
    
    switch (normalizedStatus) {
      case 'pending':
        return {
          icon: Clock,
          bgColor: 'bg-slate-100',
          textColor: 'text-slate-700',
          label: 'Pendiente'
        };
      case 'claimed':
        return {
          icon: Server,
          bgColor: 'bg-green-100',
          textColor: 'text-green-700',
          label: 'Reclamado'
        };
      case 'processing':
        return {
          icon: Cog,
          bgColor: 'bg-green-100',
          textColor: 'text-green-700',
          label: 'Procesando',
          spin: true
        };
      case 'printing':
        return {
          icon: Printer,
          bgColor: 'bg-green-100',
          textColor: 'text-green-700',
          label: 'Imprimiendo',
          pulse: true
        };
      case 'completed':
        return {
          icon: CheckCircle,
          bgColor: 'bg-green-100',
          textColor: 'text-green-700',
          label: 'Completado'
        };
      case 'failed':
        return {
          icon: XCircle,
          bgColor: 'bg-red-100',
          textColor: 'text-red-700',
          label: 'Fallido'
        };
      case 'cancelled':
        return {
          icon: XCircle,
          bgColor: 'bg-slate-100',
          textColor: 'text-slate-600',
          label: 'Cancelado'
        };
      case 'paused':
        return {
          icon: Pause,
          bgColor: 'bg-orange-100',
          textColor: 'text-orange-700',
          label: 'Pausado'
        };
      case 'retrying':
        return {
          icon: RotateCw,
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-700',
          label: 'Reintentando',
          spin: true
        };
      default:
        return {
          icon: AlertCircle,
          bgColor: 'bg-slate-100',
          textColor: 'text-slate-700',
          label: status
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${config.bgColor} ${config.textColor}`}>
      <Icon 
        size={14} 
        className={`${config.spin ? 'animate-spin' : ''} ${config.pulse ? 'animate-pulse' : ''}`}
      />
      {config.label}
    </span>
  );
};
